import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { WorkflowStatut } from '../models/models';

interface Props {
  statut?: WorkflowStatut | null;
  size?: 'small' | 'medium';
}

/**
 * Badge coloré affichant le statut actuel d'un document de vente.
 * Si aucun statut n'est défini, retourne null (rien n'est affiché).
 */
const WorkflowStatutBadge: React.FC<Props> = ({ statut, size = 'small' }) => {
  if (!statut) return null;

  return (
    <Tooltip title={statut.libelle} placement="top">
      <Chip
        label={statut.libelle}
        size={size}
        sx={{
          backgroundColor: statut.couleur ?? '#9E9E9E',
          color: '#fff',
          fontWeight: 600,
          fontSize: size === 'small' ? '0.7rem' : '0.8rem',
          height: size === 'small' ? 22 : 28,
          '& .MuiChip-label': { px: 1 },
        }}
      />
    </Tooltip>
  );
};

export default WorkflowStatutBadge;
